import { algebra2Lessons } from './algebra2Lessons';
import { trigLessons } from './trigLessons';
import { trigIdentitiesLesson } from './trigIdentitiesLesson';

// Import additional lessons for complete coverage
export const allLessons = [
  ...algebra2Lessons,
  ...trigLessons,
  trigIdentitiesLesson
];